// pubsubHandler.js
import { PUBSUB_MESSAGE_TYPES } from "../constants";

export const handlePubSubKeys = (keys, actions = {}) => {
  keys.forEach((key) => {
    switch (key.key) {
      case PUBSUB_MESSAGE_TYPES.SHOPIFY_ORDER_NOTIFICATION:
        actions.onNewShopifyOrder(key); // trigger callback if provided
        break;
      case PUBSUB_MESSAGE_TYPES.CUSTOMER_SYNC_WITH_SHOPIFY:
        actions.onCustomerSyncWithShopifyUpdate(key); // trigger callback if provided
        break;
      case PUBSUB_MESSAGE_TYPES.SHOPIFY_INTEGRATION_DISABLED:
        actions.onShopifyIntegrationDisable(key); // trigger callback if provided
        break;
      case PUBSUB_MESSAGE_TYPES.AUDIT_INITIALIZED:
        actions.onAuditInitialized(key); // trigger callback if provided
        break;
      case PUBSUB_MESSAGE_TYPES.AUDIT_COMPLETED:
        actions.onAuditCompleted(key); // trigger callback if provided
        break;
      case PUBSUB_MESSAGE_TYPES.INVENTORY_ADDED:
        actions.onInventoryAdded?.(key); // trigger callback if provided
        break;
      default:
        console.warn("⚠️ Unhandled PubSub key:", key);
    }
  });
};
